export default {
  baseApiUrl: 'https://01.dolj.ogo.taxi',
  wsUrl: 'wss://02.dolj.ogo.taxi',
  wsApiUrl: 'https://02.dolj.ogo.taxi',
  googleMapsApiKey: 'AIzaSyBt9XxAHxFg-6cVke7aItRF4NDATE_wynM',
  userAddressesUrl: 'https://05.dolj.ogo.taxi',
  mapCenter: { lat: 44.3244924, lng: 23.7905271 },
  addrApiUrl: 'https://03.dolj.ogo.taxi',
  addrApiUrlNew: 'https://places-1.ogo.taxi'
}
